module.exports = __webpack_public_path__ + "static/assets/ce6e50c9f7f1d7d4a4f51fd01993a2ce.png";